/* global fetch */

import { config } from '../config';
import { headers, APIResponse, SpanTag, stleaf, fetchAPI } from '../helpers';

/**
 * Connected apps: the AI assistant connections the signed-in user authorised
 * through the Birdi MCP connector (OAuth grants). Grants are per-user, so the
 * API scopes everything to the authenticated user — no ids are passed for the
 * listing, and revoke can only ever touch the caller's own grants.
 */

// Built inside each call (not hoisted) so it reads config.API_URL after
// config.setOpts() has run — a module-level snapshot captures the empty default.
const base = (): string => `${config.API_URL}/oauth/grants`;

/** The user's active connections: id, clientName, scope, createdAt, lastUsedAt. */
export const list = (st: SpanTag): Promise<APIResponse> =>
  fetchAPI(stleaf(st, 'ogl001'), base(), {
    method: 'GET',
    credentials: 'include',
    headers,
  });

/**
 * Org-admin only: every active connection in the caller's organisation, with
 * the person who holds it (user {id, name, email}) and the workspace it acts in.
 */
export const listOrganisation = (st: SpanTag): Promise<APIResponse> =>
  fetchAPI(stleaf(st, 'ogo001'), `${base()}/organisation`, {
    method: 'GET',
    credentials: 'include',
    headers,
  });

/**
 * Org-admin only: disconnect anyone's connection in the caller's organisation.
 * 404 if it is not live or not in that organisation.
 */
export const revokeInOrganisation = (
  st: SpanTag,
  id: string,
): Promise<APIResponse> =>
  fetchAPI(
    stleaf(st, 'ogo002'),
    `${base()}/organisation/${encodeURIComponent(id)}`,
    { method: 'DELETE', credentials: 'include', headers },
  );

/** Disconnect one connection. 404 if it is not the caller's own live grant. */
export const revoke = (st: SpanTag, id: string): Promise<APIResponse> =>
  fetchAPI(stleaf(st, 'ogr001'), `${base()}/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    credentials: 'include',
    headers,
  });
